module.exports = __webpack_public_path__ + "f1108747e009b2e3a4bea23d80ebc84e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/picmobile1.png
// module id = 1869
// module chunks = 0